import { render } from "./RaP.vue?vue&type=template&id=85bfc9d2"
import script from "./RaP.vue?vue&type=script&lang=js"
export * from "./RaP.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__